const SponsorshipsArchive = {
	init() {
		const root = document.querySelector('[data-component="sponsorships-pagination"]');
		if (!root) return;

		this.wirePerPage(root);
	},

	wirePerPage(root) {
		const select = root.querySelector('[data-per-page]');
		if (!select) return;

		select.addEventListener('change', () => {
			const url = new URL(window.location.href);
			url.searchParams.set('per_page', select.value);
			// Drop the /page/N/ path segment so we start from the first page.
			url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');
			window.location.href = url.toString();
		});
	},
};

export default SponsorshipsArchive;
